// ShareLanding.jsx
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

function base64urlDecode(s) {
  const pad = "=".repeat((4 - (s.length % 4)) % 4);
  const str = atob((s + pad).replace(/-/g, "+").replace(/_/g, "/"));
  try { return decodeURIComponent([...str].map(c => `%${c.charCodeAt(0).toString(16).padStart(2,"0")}`).join("")); }
  catch { return str; }
}

export default function ShareLanding() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const r = params.get("r");
    if (r) {
      try {
        const data = JSON.parse(base64urlDecode(r));
        // Write in the shape ResultsPage already expects
        localStorage.setItem("vybly_quiz_results", JSON.stringify({ result: data }));
      } catch {}
    }
    navigate("/results", { replace: true });
  }, [params, navigate]);

  return null; // nothing to render
}
